import React from 'react';
import Icon1 from '../images/Icon-1_Bulb.svg?react';
import Icon2 from '../images/Icon-2_Klemmbrett.svg?react';
import Icon3 from '../images/Icon-3_Schraubenschluessel.svg?react';
import { Customization, css } from '@eduvision/toolkit';
// import { default as CustomLoggedOutView } from '../views/LoggedOutView';

export const PerksSection: Customization['PerksSection'] = {
  data:[
    {
      title:'Inspiriert werden',
      description: 'Lassen Sie sich von Aktionsideen motivieren. Erfahren Sie, wie Diversity kreativ umgesetzt werden kann.',
      icon: <Icon1 />
    },
    {
      title:'Aktionen planen',
      description: 'Planen Sie konkrete Schritte und erstellen Sie maßgeschneiderte Pläne zur Förderung von Diversity.',
      icon: <Icon2 />
    },
    {
      title:'Inspiriert werden',
      description: 'Lassen Sie sich von Aktionsideen motivieren. Erfahren Sie, wie Diversity kreativ umgesetzt werden kann.',
      icon: <Icon3 />
    }
  ]
};
